module.exports = __webpack_public_path__ + "static/img/Car_1.e3abb381.png";